<template>
  <section>
    <div class="py-4 md:py-0">
      <div class="flex items-center justify-between">
        <h2 :class="['headline-sm', isUserOwner ? 'text-start' : 'w-full text-center']">
          Ofertas de empleo publicadas
        </h2>
        <Link v-if="isUserOwner" :href="$route('company.jobs.index')">
          <Button class="btn-filled brand-green fill-white" icon="settings-filled">
            Editar
          </Button>
        </Link>
      </div>
      <Divider class="hidden md:block md:!w-auto md:!mx-0" />
    </div>
    <div class="md:py-4">
      <ProfileSection>
        <template v-slot:title>Últimas ofertas publicadas</template>
        <template v-slot:content>
          <div v-if="jobs.length <= 0" class="flex flex-col gap-2 justify-center items-center">
            <Illustration name="lost" class="rounded-2xl bg-neutral99 w-full max-h-36 p-2" />
            <p class="label-lg text-center text-on-surface-variant">
              Este perfil no ha publicado ninguna oferta...
            </p>
            <Button class="btn-outlined">Explora más ofertas</Button>
          </div>
          <div v-else>
            <div class="flex flex-col gap-2">
              <ListItemWithDivider v-for="(offer, key) in jobs" :key="key.id">
                <Link :href="$route('jobposting', offer.id)" class="w-full">
                  <OfferCard :offer="{ ...offer, company }" surface show-chips />
                </Link>
              </ListItemWithDivider>
            </div>
            <div class="w-full my-4">
              <Button class="btn-outlined block mx-auto">Explora más ofertas</Button>
            </div>
          </div>
        </template>
      </ProfileSection>
    </div>
  </section>
</template>

<script>
import Illustration from '@/Components/Illustration'
import Button from '@/Components/Button'
import ButtonIcon from '@/Components/ButtonIcon'
import ProfileSection from '@/Components/ProfileSection'
import OfferCard from '@/Components/OfferCard'
import Divider from '@/Components/Divider'
import ListItemWithDivider from '@/Components/ListItemWithDivider'
import { Link } from '@inertiajs/inertia-vue'

export default {
  name: 'CompanyProfileJobsTab',
  components: {
    ButtonIcon,
    ProfileSection,
    OfferCard,
    Button,
    Illustration,
    Divider,
    Link,
    ListItemWithDivider,
  },
  data() {
    return {
      jobs_: [
        {
          id: '1',
          published_at: 1649333811,
          title: 'JobTitle 1',
          short_description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Diam fermentum, feugiat mi urna ac posuere donec malesuada.',
          company: {
            name: 'Company Name',
            profile_image: 'https://via.placeholder.com/40',
          },
        },
        {
          id: '2',
          published_at: 1649074611,
          title: 'JobTitle 2',
          short_description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Diam fermentum, feugiat mi urna ac posuere donec malesuada.',
          company: {
            name: 'Company Name',
            profile_url: '',
          },
        },
        {
          id: '3',
          published_at: 1648815411,
          title: 'JobTitle 3',
          short_description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Diam fermentum, feugiat mi urna ac posuere donec malesuada.',
          company: {
            name: 'Company Name',
            profile_url: '',
          },
        },
        {
          id: '4',
          published_at: 1648815411,
          title: 'JobTitle 3',
          short_description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Diam fermentum, feugiat mi urna ac posuere donec malesuada.',
          company: {
            name: 'Company Name',
            profile_image: 'https://via.placeholder.com/40',
          },
        },
        {
          id: '5',
          published_at: 1648815411,
          title: 'JobTitle 3',
          short_description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Diam fermentum, feugiat mi urna ac posuere donec malesuada.',
          company: {
            name: 'Company Name',
            profile_url: '',
          },
        },
      ],
    }
  },
  props: {
    company: { type: Object, required: true },
    jobs: {
      type: Array,
      required: true,
    },
    isUserOwner: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style></style>
